import axios from "axios";
const BASE_URL = process.env.REACT_APP_DEV_URL;

export const getPaymentStatus = async (token, orderId) => {
    const url = `${BASE_URL}/order/payment_summary/${orderId}/`;
  
    // console.log(url);
    
    const config = {
      headers: {
        Authorization: `Token ${token}`,
      },
    };
  
    try {
      const response = await axios.get(url, config);
      return response;
    } catch (error) {
      if (
        error.response &&
        error.response.status >= 400 &&
        error.response.status < 500
      ) {
        console.log("Client Error:", error.response);
        return error.response;
      } else {
        console.error("Server or Network Error:", error);
        throw error;
      }
    }
  };

  export const collectPayment = async (token, orderId, params = {}) => {
    const url = `${BASE_URL}/order/payment_summary/${orderId}/`;

    // console.log(token,orderId, params);
    
  
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
      params,
    };
  
    try {
      const response = await axios.post(url, {}, config);
      return response;
    } catch (error) {
      if (
        error.response &&
        error.response.status >= 400 &&
        error.response.status < 500
      ) {
        console.log("Client Error:", error.response);
        return error.response;
      } else {
        console.error("Server or Network Error:", error);
        throw error;
      }
    }
  };

  export const getAgentCommision = async (token, orderId) => {
    const url = `${BASE_URL}/order/agent_payment_commision/${orderId}/`;
  
    // console.log(url);
    
    const config = {
      headers: {
        Authorization: `Token ${token}`,
      },
    };
  
    try {
      const response = await axios.get(url, config);
      return response;
    } catch (error) {
      if (
        error.response &&
        error.response.status >= 400 &&
        error.response.status < 500
      ) {
        console.log("Client Error:", error.response);
        return error.response;
      } else {
        console.error("Server or Network Error:", error);
        throw error;
      }
    }
  };

  export const payAgentCommision = async (token, data, orderId) => {
    const url = `${BASE_URL}/order/order_id/${orderId}/`;
  
    // console.log(url, token, data);
    
    const config = {
      headers: {
        Authorization: `Token ${token}`,
      },
    };
  
    try {
      const response = await axios.patch(url, data, config);
      return response;
    } catch (error) {
      if (
        error.response &&
        error.response.status >= 400 &&
        error.response.status < 500
      ) {
        console.log("Client Error:", error.response);
        return error.response;
      } else {
        console.error("Server or Network Error:", error);
        throw error;
      }
    }
  };
